import {
  IGenerateStrategyProps,
  IStrategy,
  IStrikeData,
  Leg,
} from "../../../types";
import { analyzePositions } from "../../analyzeProfits";
import { getSpreadMargin } from "../../strategyUtils";

export const generateBullCallSpread = (
  params: IGenerateStrategyProps,
  data: IStrikeData[],
  strategies: IStrategy[],
  expiryDuration: number
): IStrategy[] => {
  for (let i = 0; i < data.length; i++) {
    for (let j = i + 1; j < data.length; j++) {
      const legs: Leg[] = [
        {
          strikePrice: data[i].strikePrice,
          call: true,
          buy: true,
          quantity: params.lotSize,
          price: data[i].CE?.lastPrice || 0,
        },
        {
          strikePrice: data[j].strikePrice,
          call: true,
          buy: false,
          quantity: -params.lotSize,
          price: data[j].CE?.lastPrice || 0,
        },
      ];
      const analysis = analyzePositions(legs);
      const approxMargin = getSpreadMargin(
        params,
        legs[0].strikePrice,
        legs[1].strikePrice,
        legs[0].quantity
      );
      const maxLossROI = (analysis.maxLoss / approxMargin) * 100;
      const strategy: IStrategy = {
        title:
          "Bull call spread " +
          data[i].strikePrice +
          " - " +
          data[j].strikePrice,
        legs: legs,
        callBreakEven: analysis.breakEven.callBreakEven,
        callBreakEvenPercentage:
          ((analysis.breakEven.callBreakEven - params.data.underlyingValue) /
            params.data.underlyingValue) *
          100,
        maxLoss: analysis.maxLoss,
        maxProfit: analysis.maxProfit,
        riskRewardRatio: analysis.maxProfit / analysis.maxLoss,
        maxLossROI,
        maxProfitROI: (analysis.maxProfit / approxMargin) * 100,
        approxMargin: approxMargin,
        expiryDuration: expiryDuration,
        lotSize: params.lotSize,
        alert:
          maxLossROI > 15
            ? "Max loss greater than 15% of cost"
            : undefined,
      };
      if (
        legs[0].price > 10 && //avoid non-liquid options
        legs[1].price > 10
      )
        strategies.push(strategy);
    }
  }
  return strategies;
};
